require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-articles-financial-center-first-credit-union-selected-for-national-credit-union-foundations-at-risk-youth-financial-well-being-grant.json") })
        }
      }, "path---es-articles-financial-center-first-credit-union-selected-for-national-credit-union-foundations-at-risk-youth-financial-well-being-grant");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-articles-financial-center-first-credit-union-selected-for-national-credit-union-foundations-at-risk-youth-financial-well-being-grant!./.cache/json/es-articles-financial-center-first-credit-union-selected-for-national-credit-union-foundations-at-risk-youth-financial-well-being-grant.json
// module id = 2125
// module chunks = 231608221292675